<template>
  <v-flex xs12 sm8 md6 v-cloak v-show="!currentLoggedUser.email">
    <v-card class="elevation-12">
      <v-toolbar dark color="primary">
        <v-toolbar-title>Login</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-text-field
            prepend-icon="mail"
            maxlength="50"
            counter
            v-model="email"
            placeholder="mail"
            :rules="emailRules"
            label="E-mail"
            :value="emailLogin"
            @input="setEmailLogin"
            @keyup.enter.native="login()"
            required
          ></v-text-field>
          <v-text-field
            required
            :rules="passwordRules"
            maxlength="20"
            counter
            placeholder="password"
            id="password"
            prepend-icon="lock"
            name="password"
            label="Password"
            :append-icon="show2 ? 'visibility' : 'visibility_off'"
            :type="show2 ? 'text' : 'password'"
            v-model="password"
            @input="setPasswordLogin"
            :value="passwordLogin"
            @click:append="show2 = !show2"
            @keyup.enter.native="login()"
          ></v-text-field>
        </v-form>

        <v-switch v-model="switch1" label="Ricordami" @change="setRememberLogin"></v-switch>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="login();">Login</v-btn>
      </v-card-actions>
      <v-snackbar
        v-cloak
        v-model="snackbar"
        :color="color"
        :bottom="y === 'bottom'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :right="x === 'right'"
        :timeout="timeout"
        :top="y === 'top'"
        :vertical="mode === 'vertical'"
      >
        <span style="display:none" v-html="loginError"></span>
        <strong>{{ messageSnackbar }}</strong>
        <v-btn color="white" flat @click="snackbar = false">
          <strong>Chiudi</strong>
        </v-btn>
      </v-snackbar>
    </v-card>
  </v-flex>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import config from "../../configuration.json";
import axios from "axios";
import router from "../router";

export default {
  data: () => ({
    email: "",
    show2: false,
    snackbar: false,
    y: "top",
    x: null,
    mode: "",
    timeout: 6000,
    password: "",
    errorLogin: false,
    showSearchbox: false,
    color: "red",
    checkbox: true,
    radioGroup: 1,
    currentLoggedUser: "",
    switch1: true,
    messageSnackbar: "",
    user: "",
    passwordRules: [
      v => !!v || "Password obbligatoria",
      v => v.length >= 6 || "La password deve essere di almeno 6 caratteri",
      v => v.length <= 20 || "Password troppo lunga"
    ],
    emailRules: [
      value => !!value || "E-mail obbligatoria",
      value =>
        /^[A-z0-9\.\+_-]+@[A-z0-9\._-]+\.[A-z]{2,6}$/.test(value) ||
        "E-mail non valida",
      value => value.length <= 50 || "Email troppo lunga"
    ]
  }),
  computed: {
    ...mapState("authentication", [
      "emailLogin",
      "passwordLogin",
      "loginError",
      "loggedUser"
    ]) //mapState è il binding tra le variabili dello store e le views.
  },
  mounted() {
    console.log("a");
    this.getInfo(); //va a richiamare getInfo di mapActions
    this.$store.subscribe((mutation, state) => {
      switch (mutation.type) {
        case "authentication/setLoggedUser":
          let temp = this.$store.state.authentication.loggedUser;
          this.currentLoggedUser = JSON.parse(temp);
          if (this.currentLoggedUser.email && this.$route.path != "/users" && this.$route.path != "/assets") {
            router.push("/builder");
          }
          break;
      }
    });
  },
  watch: {
    loginError(loginStatus, oldValue) {
      //lo snackbar viene visualizzato solo ogni volta che cambia la mail errata, se la mail rimane la stessa errata non lo mostra piu di una volta
      if (loginStatus) {
        loginStatus = JSON.parse(loginStatus);
        this.snackbar = loginStatus.show;
        this.color = loginStatus.color;
        this.messageSnackbar = loginStatus.message;
      }
    },
    emailLogin(newEmail,old){
      if(newEmail.length > 50){
          this.emailLogin = newEmail.substring(0,50);
          this.email = newEmail;
      }
      else{
      this.email = newEmail
      }
    }
  },
  methods: {
    //authentication è lo store, se ne possono fare anche altri, si comporta come il controller MVC.
    ...mapActions("authentication", ["getInfo", "login"]), //mapActions sono le funzioni che vengono richiamate nello store, triggerati da @click
    ...mapMutations("authentication", [
      "setEmailLogin",
      "setPasswordLogin",
      "setRememberLogin",
      "setErrorLogin"
    ]), //mapMutation sono gli eventi che settano le variabili nello store, triggerati da @input
    ...mapGetters({
      // map `this.doneCount` to `this.$store.getters.doneTodosCount`
      getLoginError: "getLoginError",
      getLoggedUser: "getLoggedUser"
    }),
  }
};
</script>
